import { Component, OnInit } from '@angular/core';
import { SsoLogin } from '../../core/services/sso-login.service';
import { getCurrentLanguage } from '../../core/i18n/translation-locale';
import { loginPageTranslationsEn } from '../../../assets/translations/en/loginPage';
import { loginPageTranslationsFr } from '../../../assets/translations/fr/loginPage';
import { SsoPkceUtil } from '../../core/utils/sso-pkce.util';
import { environment } from '../../../environments/environment';
import { PagesService } from '../pages.service';
import { CommonModule } from '@angular/common';
import { CmsComponentData } from '@spartacus/storefront';
import { map, Observable, switchMap, take, tap } from 'rxjs';
import { CmsService, OccCmsComponentAdapter, RoutingService } from '@spartacus/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
})
export class LoginPage implements OnInit {
  private readonly language = getCurrentLanguage();
  readonly translations = this.language === 'fr' ? loginPageTranslationsFr : loginPageTranslationsEn;
  isSessionExpired$: any;
  loginErrorMessage$: any;
  currentIdleTimeout$: Observable<number>;
  componentData$: Observable<any>;
  
  navLinks = [];
  navContent = {
    link: this.navLinks,
    loginStatus: false,
  };
  environment: any = environment;
  links$: Observable<any[]>;
  linksInfo$ = new Observable<any[]>();
  componentName: any;
  loginComponent$: Observable<any>;
  baseUrl: string = environment.baseUrl;
  constructor(
    private ssoLoginService: SsoLogin, 
    private pagesService: PagesService,
    private occCmsService: OccCmsComponentAdapter,
    private routingService: RoutingService,
    private componentData: CmsComponentData<any>
  ) {
    // Get the dynamic component UID from CmsComponentData
    const componentUid = this.componentData?.uid;
    this.loginComponent$ = this.routingService.getPageContext().pipe(
      take(1),
      switchMap(pageContext =>
        this.occCmsService.findComponentsByIds(
          [componentUid],
          pageContext
        )
      ),
      map((components: any[]) => components?.[0] || null)
    );
  }
  
  ngOnInit() {
    this.pagesService.updateNavigationNodes(this.navContent);
    this.isSessionExpired$ = this.pagesService.isSessionExpired$;
    this.loginErrorMessage$ = this.ssoLoginService.loginErrorMessage$;
    this.currentIdleTimeout$ = this.pagesService.currentIdleTimeout$;
  }

   async onSsoLogin(): Promise<void> {
    const { verifier, challenge } = await SsoPkceUtil.generatePkcePair();
    const redirect_uri = environment.redirectUri;
    const tenant_id = environment.tenant_id;
    const client_id = environment.clientId;
    this.ssoLoginService.storeAuthorizationRequest(verifier);
    const url = new URL(`https://login.microsoftonline.com/${tenant_id}/oauth2/v2.0/authorize`);
    url.searchParams.set('client_id', client_id);
    url.searchParams.set('response_type', 'code');
    url.searchParams.set('redirect_uri', redirect_uri);
    url.searchParams.set('scope', 'openid profile email User.Read');
    url.searchParams.set('code_challenge', challenge);
    url.searchParams.set('code_challenge_method', 'S256');
    window.open(url, '_self');
    window.scrollTo(0, 0);
  }
}